import { ResponsiveBar } from '@nivo/bar';
import { VeltNivoChartComments } from '@veltdev/react';
import React, { useState } from 'react'

const dataset1 = [
    {
        "country": "AD",
        "hot dog": 104,
        "hot dogColor": "hsl(93, 70%, 50%)",
        "burger": 195,
        "burgerColor": "hsl(348, 70%, 50%)",
        "sandwich": 78,
        "sandwichColor": "hsl(266, 70%, 50%)",
        "kebab": 38,
        "kebabColor": "hsl(226, 70%, 50%)",
        "fries": 29,
        "friesColor": "hsl(164, 70%, 50%)",
        "donut": 85,
        "donutColor": "hsl(159, 70%, 50%)"
    },
    {
        "country": "AE",
        "hot dog": 5,
        "hot dogColor": "hsl(188, 70%, 50%)",
        "burger": 20,
        "burgerColor": "hsl(115, 70%, 50%)",
        "sandwich": 176,
        "sandwichColor": "hsl(329, 70%, 50%)",
        "kebab": 194,
        "kebabColor": "hsl(323, 70%, 50%)",
        "fries": 78,
        "friesColor": "hsl(279, 70%, 50%)",
        "donut": 29,
        "donutColor": "hsl(273, 70%, 50%)"
    },
    {
        "country": "AF",
        "hot dog": 85,
        "hot dogColor": "hsl(87, 70%, 50%)",
        "burger": 106,
        "burgerColor": "hsl(245, 70%, 50%)",
        "sandwich": 42,
        "sandwichColor": "hsl(170, 70%, 50%)",
        "kebab": 86,
        "kebabColor": "hsl(215, 70%, 50%)",
        "fries": 180,
        "friesColor": "hsl(228, 70%, 50%)",
        "donut": 59,
        "donutColor": "hsl(13, 70%, 50%)"
    },
    {
        "country": "AG",
        "hot dog": 91,
        "hot dogColor": "hsl(45, 70%, 50%)",
        "burger": 96,
        "burgerColor": "hsl(336, 70%, 50%)",
        "sandwich": 127,
        "sandwichColor": "hsl(54, 70%, 50%)",
        "kebab": 54,
        "kebabColor": "hsl(115, 70%, 50%)",
        "fries": 39,
        "friesColor": "hsl(251, 70%, 50%)",
        "donut": 11,
        "donutColor": "hsl(203, 70%, 50%)"
    },
    {
        "country": "AI",
        "hot dog": 22,
        "hot dogColor": "hsl(11, 70%, 50%)",
        "burger": 81,
        "burgerColor": "hsl(91, 70%, 50%)",
        "sandwich": 25,
        "sandwichColor": "hsl(320, 70%, 50%)",
        "kebab": 142,
        "kebabColor": "hsl(178, 70%, 50%)",
        "fries": 162,
        "friesColor": "hsl(201, 70%, 50%)",
        "donut": 64,
        "donutColor": "hsl(331, 70%, 50%)"
    },
    {
        "country": "AL",
        "hot dog": 38,
        "hot dogColor": "hsl(238, 70%, 50%)",
        "burger": 156,
        "burgerColor": "hsl(306, 70%, 50%)",
        "sandwich": 86,
        "sandwichColor": "hsl(11, 70%, 50%)",
        "kebab": 24,
        "kebabColor": "hsl(101, 70%, 50%)",
        "fries": 134,
        "friesColor": "hsl(276, 70%, 50%)",
        "donut": 156,
        "donutColor": "hsl(341, 70%, 50%)"
    },
    {
        "country": "AM",
        "hot dog": 158,
        "hot dogColor": "hsl(341, 70%, 50%)",
        "burger": 184,
        "burgerColor": "hsl(126, 70%, 50%)",
        "sandwich": 16,
        "sandwichColor": "hsl(322, 70%, 50%)",
        "kebab": 195,
        "kebabColor": "hsl(171, 70%, 50%)",
        "fries": 163,
        "friesColor": "hsl(139, 70%, 50%)",
        "donut": 15,
        "donutColor": "hsl(216, 70%, 50%)"
    }
];

const dataset2 = [
    {
        "country": "AD",
        "hot dog": 141,
        "hot dogColor": "hsl(350, 70%, 50%)",
        "burger": 157,
        "burgerColor": "hsl(283, 70%, 50%)",
        "sandwich": 57,
        "sandwichColor": "hsl(148, 70%, 50%)",
        "kebab": 139,
        "kebabColor": "hsl(93, 70%, 50%)",
        "fries": 95,
        "friesColor": "hsl(301, 70%, 50%)",
        "donut": 45,
        "donutColor": "hsl(138, 70%, 50%)"
    },
    {
        "country": "AE",
        "hot dog": 96,
        "hot dogColor": "hsl(124, 70%, 50%)",
        "burger": 173,
        "burgerColor": "hsl(134, 70%, 50%)",
        "sandwich": 78,
        "sandwichColor": "hsl(77, 70%, 50%)",
        "kebab": 134,
        "kebabColor": "hsl(173, 70%, 50%)",
        "fries": 122,
        "friesColor": "hsl(290, 70%, 50%)",
        "donut": 150,
        "donutColor": "hsl(50, 70%, 50%)"
    },
    {
        "country": "AF",
        "hot dog": 69,
        "hot dogColor": "hsl(154, 70%, 50%)",
        "burger": 117,
        "burgerColor": "hsl(219, 70%, 50%)",
        "sandwich": 67,
        "sandwichColor": "hsl(101, 70%, 50%)",
        "kebab": 35,
        "kebabColor": "hsl(318, 70%, 50%)",
        "fries": 192,
        "friesColor": "hsl(144, 70%, 50%)",
        "donut": 114,
        "donutColor": "hsl(9, 70%, 50%)"
    },
    {
        "country": "AG",
        "hot dog": 194,
        "hot dogColor": "hsl(315, 70%, 50%)",
        "burger": 51,
        "burgerColor": "hsl(350, 70%, 50%)",
        "sandwich": 35,
        "sandwichColor": "hsl(224, 70%, 50%)",
        "kebab": 128,
        "kebabColor": "hsl(19, 70%, 50%)",
        "fries": 193,
        "friesColor": "hsl(85, 70%, 50%)",
        "donut": 37,
        "donutColor": "hsl(273, 70%, 50%)"
    },
    {
        "country": "AI",
        "hot dog": 144,
        "hot dogColor": "hsl(358, 70%, 50%)",
        "burger": 33,
        "burgerColor": "hsl(140, 70%, 50%)",
        "sandwich": 43,
        "sandwichColor": "hsl(279, 70%, 50%)",
        "kebab": 156,
        "kebabColor": "hsl(232, 70%, 50%)",
        "fries": 124,
        "friesColor": "hsl(200, 70%, 50%)",
        "donut": 64,
        "donutColor": "hsl(241, 70%, 50%)"
    },
    {
        "country": "AL",
        "hot dog": 113,
        "hot dogColor": "hsl(359, 70%, 50%)",
        "burger": 157,
        "burgerColor": "hsl(6, 70%, 50%)",
        "sandwich": 140,
        "sandwichColor": "hsl(171, 70%, 50%)",
        "kebab": 186,
        "kebabColor": "hsl(284, 70%, 50%)",
        "fries": 30,
        "friesColor": "hsl(29, 70%, 50%)",
        "donut": 126,
        "donutColor": "hsl(189, 70%, 50%)"
    },
    {
        "country": "AM",
        "hot dog": 149,
        "hot dogColor": "hsl(22, 70%, 50%)",
        "burger": 24,
        "burgerColor": "hsl(117, 70%, 50%)",
        "sandwich": 61,
        "sandwichColor": "hsl(188, 70%, 50%)",
        "kebab": 17,
        "kebabColor": "hsl(241, 70%, 50%)",
        "fries": 178,
        "friesColor": "hsl(285, 70%, 50%)",
        "donut": 78,
        "donutColor": "hsl(54, 70%, 50%)"
    }
];

const dataset3 = [
    {
        "country": "AD",
        "hot dog": 28,
        "hot dogColor": "hsl(158, 70%, 50%)",
        "burger": 131,
        "burgerColor": "hsl(139, 70%, 50%)",
        "sandwich": 153,
        "sandwichColor": "hsl(41, 70%, 50%)",
        "kebab": 6,
        "kebabColor": "hsl(96, 70%, 50%)",
        "fries": 1,
        "friesColor": "hsl(341, 70%, 50%)",
        "donut": 169,
        "donutColor": "hsl(101, 70%, 50%)"
    },
    {
        "country": "AE",
        "hot dog": 48,
        "hot dogColor": "hsl(289, 70%, 50%)",
        "burger": 194,
        "burgerColor": "hsl(74, 70%, 50%)",
        "sandwich": 137,
        "sandwichColor": "hsl(287, 70%, 50%)",
        "kebab": 160,
        "kebabColor": "hsl(34, 70%, 50%)",
        "fries": 135,
        "friesColor": "hsl(248, 70%, 50%)",
        "donut": 188,
        "donutColor": "hsl(0, 70%, 50%)"
    },
    {
        "country": "AF",
        "hot dog": 150,
        "hot dogColor": "hsl(337, 70%, 50%)",
        "burger": 60,
        "burgerColor": "hsl(134, 70%, 50%)",
        "sandwich": 4,
        "sandwichColor": "hsl(55, 70%, 50%)",
        "kebab": 196,
        "kebabColor": "hsl(253, 70%, 50%)",
        "fries": 152,
        "friesColor": "hsl(42, 70%, 50%)",
        "donut": 185,
        "donutColor": "hsl(263, 70%, 50%)"
    },
    {
        "country": "AG",
        "hot dog": 183,
        "hot dogColor": "hsl(176, 70%, 50%)",
        "burger": 184,
        "burgerColor": "hsl(294, 70%, 50%)",
        "sandwich": 171,
        "sandwichColor": "hsl(0, 70%, 50%)",
        "kebab": 63,
        "kebabColor": "hsl(266, 70%, 50%)",
        "fries": 111,
        "friesColor": "hsl(170, 70%, 50%)",
        "donut": 8,
        "donutColor": "hsl(247, 70%, 50%)"
    },
    {
        "country": "AI",
        "hot dog": 179,
        "hot dogColor": "hsl(302, 70%, 50%)",
        "burger": 161,
        "burgerColor": "hsl(247, 70%, 50%)",
        "sandwich": 98,
        "sandwichColor": "hsl(275, 70%, 50%)",
        "kebab": 117,
        "kebabColor": "hsl(266, 70%, 50%)",
        "fries": 124,
        "friesColor": "hsl(117, 70%, 50%)",
        "donut": 89,
        "donutColor": "hsl(244, 70%, 50%)"
    },
    {
        "country": "AL",
        "hot dog": 124,
        "hot dogColor": "hsl(4, 70%, 50%)",
        "burger": 124,
        "burgerColor": "hsl(233, 70%, 50%)",
        "sandwich": 91,
        "sandwichColor": "hsl(6, 70%, 50%)",
        "kebab": 2,
        "kebabColor": "hsl(84, 70%, 50%)",
        "fries": 169,
        "friesColor": "hsl(45, 70%, 50%)",
        "donut": 183,
        "donutColor": "hsl(256, 70%, 50%)"
    },
    {
        "country": "AM",
        "hot dog": 138,
        "hot dogColor": "hsl(51, 70%, 50%)",
        "burger": 145,
        "burgerColor": "hsl(24, 70%, 50%)",
        "sandwich": 71,
        "sandwichColor": "hsl(248, 70%, 50%)",
        "kebab": 15,
        "kebabColor": "hsl(56, 70%, 50%)",
        "fries": 121,
        "friesColor": "hsl(46, 70%, 50%)",
        "donut": 36,
        "donutColor": "hsl(295, 70%, 50%)"
    }
];

const datasets = {
    'dataset1': {
        id: 'dataset1',
        label: 'Dataset 1',
        data: JSON.parse(JSON.stringify(dataset1))
    },
    'dataset2': {
        id: 'dataset2',
        label: 'Dataset 2',
        data: JSON.parse(JSON.stringify(dataset2))
    },
    'dataset3': {
        id: 'dataset3',
        label: 'Dataset 3',
        data: JSON.parse(JSON.stringify(dataset3))
    },
}

function NivoBarChartExample() {

    const [selectedDataset, setSelectedDataset] = useState(datasets.dataset1);

    return (
        <div>
            <h3>Bar chart</h3>
            <div className='nivo-charts-tabs'>
                {
                    Object.values(datasets).map((dataset) => (
                        <div
                            key={dataset.id}
                            className={`nivo-charts-tab ${dataset?.id === selectedDataset?.id ? 'active' : ''}`}
                            onClick={() => setSelectedDataset(dataset)}
                        >
                            {dataset.label}
                        </div>
                    ))
                }
            </div>
            <div style={{ height: 400, width: '100%' }} className='nivo-chart-container'>
                <ResponsiveBar
                    animate={false}
                    data={selectedDataset.data}
                    keys={[
                        'hot dog',
                        'burger',
                        'sandwich',
                        'kebab',
                        'fries',
                        'donut'
                    ]}
                    indexBy="country"
                    margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
                    padding={0.3}
                    valueScale={{ type: 'linear' }}
                    indexScale={{ type: 'band', round: true }}
                    colors={{ scheme: 'nivo' }}
                    layers={[
                        'grid',
                        'axes',
                        'bars',
                        'markers',
                        'legends',
                        'annotations',
                        (chartComputedData: any) => {
                            return (
                                <VeltNivoChartComments id="NivoBarChartExample" chartComputedData={chartComputedData} />
                            )
                        }
                    ]}
                    defs={[
                        {
                            id: 'dots',
                            type: 'patternDots',
                            background: 'inherit',
                            color: '#38bcb2',
                            size: 4,
                            padding: 1,
                            stagger: true
                        },
                        {
                            id: 'lines',
                            type: 'patternLines',
                            background: 'inherit',
                            color: '#eed312',
                            rotation: -45,
                            lineWidth: 6,
                            spacing: 10
                        }
                    ]}
                    fill={[
                        {
                            match: {
                                id: 'fries'
                            },
                            id: 'dots'
                        },
                        {
                            match: {
                                id: 'sandwich'
                            },
                            id: 'lines'
                        }
                    ]}
                    borderColor={{
                        from: 'color',
                        modifiers: [
                            [
                                'darker',
                                1.6
                            ]
                        ]
                    }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'country',
                        legendPosition: 'middle',
                        legendOffset: 32,
                        truncateTickAt: 0
                    }}
                    axisLeft={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'food',
                        legendPosition: 'middle',
                        legendOffset: -40,
                        truncateTickAt: 0
                    }}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor={{
                        from: 'color',
                        modifiers: [
                            [
                                'darker',
                                1.6
                            ]
                        ]
                    }}
                    legends={[
                        {
                            dataFrom: 'keys',
                            anchor: 'bottom-right',
                            direction: 'column',
                            justify: false,
                            translateX: 120,
                            translateY: 0,
                            itemsSpacing: 2,
                            itemWidth: 100,
                            itemHeight: 20,
                            itemDirection: 'left-to-right',
                            itemOpacity: 0.85,
                            symbolSize: 20,
                            effects: [
                                {
                                    on: 'hover',
                                    style: {
                                        itemOpacity: 1
                                    }
                                }
                            ]
                        }
                    ]}
                    role="application"
                    ariaLabel="Nivo bar chart demo"
                    barAriaLabel={e => e.id + ": " + e.formattedValue + " in country: " + e.indexValue}
                />
            </div>
        </div>
    )
}

export default NivoBarChartExample;